import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=0742c489&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=0742c489&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0742c489')) {
      api.createRecord('0742c489', component.options)
    } else {
      api.reload('0742c489', component.options)
    }
    module.hot.accept("./phone.vue?vue&type=template&id=0742c489&", function () {
      api.rerender('0742c489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/phone.vue"
export default component.exports